<template>
    <div class="wrapper">
        <div class="tit">How to place an order</div>
        <div class="card">
            <div class="tip">1</div>
            <div class="title">Step One</div>
            <p style="margin-bottom: 30px;">
                "Before placing an order, you must have a GiGwi account.
                (If you already have an account, please skip this step.Go to <span @click="scrollToDiv"
                    style="color: #CA141D;cursor: pointer;">Step 2</span>.)"
            </p>
            <p class="titles">1.1 Register an account.</p>
            <p class="smtit">
                Click to enter the "sign up" page from the navigation bar.
            </p>
            <div>
                <img src="../assets/imgs/uploads/1register.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <p class="smtit">
                Please provide the required information step by step. Ensure that your details are clear and thorough.
                Fields marked with an asterisk (*) are mandatory.
            </p>
            <div>
                <img src="../assets/imgs/uploads/2info.png" alt="" style="width: 100%;height: 100%;">
                <div style="font-size: 20px;display: flex;justify-content: center;">......</div>   
            </div>
            <p class="smtit">
                Once all the information has been submitted, it will be reviewed by the GiGwi sales manager. This process
                typically takes one business day. Upon approval, your account details and password will be sent to your
                email.
            </p>
            <p class="smtit">If you do not receive a response, you can also reach out to us at info@gigwi.com.hk.</p>
            <el-divider></el-divider>
            <p class="titles">1.2 Change your password</p>
            <p class="smtit">
                Upon receiving your account, it is recommended that you change the password to something easy for you to
                remember. (Please follow the steps below.)
            </p>
            <div>
                <img src="../assets/imgs/uploads/7pwd.png" alt="" style="width: 100%;height: 100%;">
                <img src="../assets/imgs/uploads/8pwd.png" alt="" style="width: 100%;height: 100%;margin-top: 40px;">
            </div>
        </div>
        <div ref="targetDiv"></div>
        <div class="card" style="margin-top: 100px;margin-bottom: 80px;">
            <div class="tip">2</div>
            <div class="title">Step Two</div>
            <p class="titles">2.1Choose the products which you want to buy.</p>
            <p class="smtit">
                Click 'Place an Order' (located under the 'Products' button on the navigation bar) to make a quick
                selection.
            </p>
            <div>
                <img src="../assets/imgs/uploads/9order.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <p class="smtit">By default, you will select products from our inventory. You may also choose additional
                products from the 'Pre-order' section, but please note that these items have a minimum order quantity (MOQ)
                of 1,200 units and require a two-month production period.</p>
            <div>
                <img src="../assets/imgs/uploads/10order.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <p class="smtit">You can click "More" to view additional product information.</p>
            <div>
                <img src="../assets/imgs/uploads/11order.png" alt="" style="width: 100%;height: 100%;">
                <img src="../assets/imgs/uploads/12order.png" alt="" style="width: 100%;height: 100%;margin-top: 40px;">
            </div>
            <p class="smtit">When you update the quantity, it will be automatically added to your shopping cart. The
                quantity will
                increase or decrease by the MOQ per adjustment (one carton). If your order quantity does not match the
                required MOQ, please contact our sales representative after placing the order. If possible, they will adjust
                the order accordingly.</p>
            <div>
                <img src="../assets/imgs/uploads/13order.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <el-divider></el-divider>
            <p class="titles">2.2 place an order</p>
            <p class="smtit">Once the order is submitted from the shopping cart, it cannot be modified by the customer. To
                make any changes, please contact our sales representative.</p>
            <div>
                <img src="../assets/imgs/uploads/14order.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <el-divider></el-divider>
            <p class="titles">2.3 Fill in your shipping address</p>
            <p class="smtit">If this is your first time submitting an order on our website, you will need to provide a
                shipping address. This can be either your local warehouse or a warehouse in China designated by your
                logistics company.</p>
            <div>
                <img src="../assets/imgs/uploads/15order.png" alt="" style="width: 100%;height: 100%;">
                <img src="../assets/imgs/uploads/16order.png" alt="" style="width: 100%;height: 100%;margin-top: 40px;">
            </div>
            <el-divider></el-divider>
            <p class="titles">2.4 submit your order.</p>
            <div>
                <img src="../assets/imgs/uploads/17order.png" alt="" style="width: 100%;height: 100%;">
                <img src="../assets/imgs/uploads/18order.png" alt="" style="width: 100%;height: 100%;margin-top: 40px;">
            </div>
            <el-divider></el-divider>
            <p style="font-size: 18px;font-weight: bold;">After you submit the order, our sales representative will contact
                you within one
                business day. If you do not receive a response, you can also reach us at info@gigwi.com.hk. </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timer: null,
        }
    },
    activated() {
        this.timer = setTimeout(() => {
            this.recordVisit();
        }, 10000); // 30秒后执行记录
    },
    destroyed() {
        // 清除计时器，在组件销毁时清除计时器，以防止内存泄漏
        clearTimeout(this.timer);
    },
    methods: {
        scrollToDiv() {
            // 通过 this.$refs 访问目标 div
            const targetElement = this.$refs.targetDiv;
            if (targetElement) {
                // 使用 scrollIntoView 进行滚动
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        },
        recordVisit() {
            // 记录用户访问信息，可以发送网络请求或者调用其他逻辑
            this.$axios
                .post("/api/mall/log/save",
                    {
                        userId: this.$store.getters.getUser.id ? this.$store.getters.getUser.id : '',
                        browse: '如何下单页',
                        browseTime: 10,
                    })
        },
    },
}
</script>

<style scoped>
.wrapper {
    width: 1280px;
    margin: 0 auto;
    color: #000;
}

.card {
    border: 2px solid #CA141D;
    border-radius: 15px;
    position: relative;
    padding: 47px 100px 83px;
    background-color: #FFF3F2;
}

::v-deep .el-divider {
    background-color: #CA141D;
}

.tip {
    position: absolute;
    width: 65px;
    height: 65px;
    font-weight: bold;
    font-size: 30px;
    color: #fff;
    padding: 5px 0 0 20px;
    border-radius: 15px 0 65px;
    background-color: #CA141D;
    top: -1px;
    left: -1px;
}

.smtit {
    font-weight: bold;
    font-size: 14px;
    margin: 20px 0;
}

.tit {
    font-size: 36px;
    font-weight: bold;
    margin: 69px 0 31px;
}

.title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #CA141D;
}

.titles {
    margin-top: 10px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
}
</style>